const firebaseConfig = {
  apiKey: "AIzaSyBWzfoc-TsST_RbsttCqWiNlDbUF6bRq4I",
  authDomain: "red-onion-food-shop.firebaseapp.com",
  projectId: "red-onion-food-shop",
  storageBucket: "red-onion-food-shop.appspot.com",
  messagingSenderId: "577645791834",
  appId: "1:577645791834:web:0a8111144bda71c388e663",
};
export default firebaseConfig;